import React from 'react';
import './PlatformSelector.css';

interface PlatformSelectorProps {
  currentPlatform: 'camel' | 'starlink' | 'shadow';
  onPlatformChange: (platform: 'camel' | 'starlink' | 'shadow') => void;
}

const PlatformSelector: React.FC<PlatformSelectorProps> = ({ currentPlatform, onPlatformChange }) => {
  return (
    <div className="platform-selector">
      <div className="platform-selector-label">Platform:</div>
      <button
        className={`platform-btn camel-btn ${currentPlatform === 'camel' ? 'active' : ''}`}
        onClick={() => onPlatformChange('camel')}
      >
        <span className="platform-icon">🐫</span>
        CAMEL
        <span className="platform-badge camel-badge">Karma</span>
      </button>
      <button
        className={`platform-btn starlink-btn ${currentPlatform === 'starlink' ? 'active' : ''}`}
        onClick={() => onPlatformChange('starlink')}
      >
        <span className="platform-icon">⭐</span>
        STARLINK
        <span className="platform-badge starlink-badge">Direct</span>
      </button>
      <button
        className={`platform-btn shadow-btn ${currentPlatform === 'shadow' ? 'active' : ''}`}
        onClick={() => onPlatformChange('shadow')}
      >
        <span className="platform-icon">🌑</span>
        SHADOW
        <span className="platform-badge shadow-badge">MyAsset</span>
      </button>
    </div>
  );
};

export default PlatformSelector;
